export default "__VITE_ASSET__CFrtO9GP__"